import React from 'react';
import './AdminDashboard.css';
import '../styles/dashboard/style.css';
import '../styles/dashboard/dashboard.css';
import '../styles/dashboard/modal.css';
import '../styles/dashboard/responsive.css';
import { AppProvider } from '../context/AppContext';
import { MainContent } from './dashboard/MainContent';
import { Sidebar } from './dashboard/Sidebar';
import { AssignModal } from './dashboard/AssignModal';
import { ManageModal } from './dashboard/ManageModal';
import { AdminFirebaseActions } from './admin/AdminFirebaseActions';

const AdminDashboard = ({ onLogout }) => {
  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="header-content">
          <h1>Tableau de bord — Suivi du temps</h1>
          <div className="header-actions">
            <button type="button" onClick={onLogout} className="logout-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16,17 21,12 16,7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Déconnexion
            </button>
          </div>
        </div>
      </header>

      <AppProvider>
        <div className="time-tracking-dashboard">
          <div className="shell">
            <Sidebar adminSection={<AdminFirebaseActions />} />
            <MainContent />
            <AssignModal />
            <ManageModal />
          </div>
        </div>
      </AppProvider>
    </div>
  );
};

export default AdminDashboard;
